/* eslint-disable arrow-parens */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import {
  GET_USER_COMPANY_GQL,
  UPDATE_COMPANY_GQL,
  ADD_COMPANY_BUDGET_HISTORY_GQL,
  COPY_CATEGORY_GQL,
  SET_COMPANY_KYC,
  GET_COMPANY_HISTORY_GQL,
  GET_COMPANY_LIST_GQL,
  UPDATE_COMPANY_DATA_GQL,
  GET_PDF_HISTORY,
  PUT_NEW_ADDRESS,
  PUT_NEW_BILLING_ADDRESS,
  SET_CHILD_COMPANIES,
  GET_CHILD_COMPANIES,
  REMOVE_CHILD_COMPANIES,
  GET_COMPANY_USERS_GQL,
  GET_COMPANIES_ORDER_BY_BAL_GQL,
  GET_ACH_NETWORK_GQL,
  GET_METAL_CARD_GQL,
  GET_INDUSTRY_CLASSIFICATION_GQL,
  GET_BUSINESS_CLASSIFICATION_GQL,
  UPDATE_COMPANY_CLASSIFICATION_DATA_GQL,
  GET_COMPANIES_ORDER_BY_BAL_GQL_CUSTOM,
  GET_SUPPORT_ADMIN_PERMISSION_LIST_GQL,
  GET_TYPEID_FROM_NAME_GQL,
  GET_SUPPORT_ADMIN_LIST_GQL,
  GET_SUPPORT_ADMIN_INFO_GQL,
  SET_SKIP_REKYC_OPERATION_GQL,
  SET_SUBMIT_REKYC_GQL,
} from '@/graphql/queries.gql';

export default {
  namespaced: true,

  state: {
    skipReKYCOperationResponse: null,
    submitKYCResponse: null,
    getAllCompanyList: [],
    updatedCompInfo: [],
    setCompanyBudgetHistory: [],
    totalCategoryCount: 0,
    setKycData: null,
    companyUpdateData: null,
    getCompanyHistory: [],
    getAllCompanyName: [],
    setPdfDate: [],
    NewAddress: null,
    NewBillingAddress: null,
    listOfChildCompany: [],
    addReturnChild: null,
    removeReturnChild: null,
    getCompanyWiseUsers: [],
    getCompaniesSortByBal: [],
    achNetworks: [],
    metalCardList: [],
    industryClassificationList: [],
    businessClassificationList: [],
    updatedCompClassInfo: null,
    getCompaniesSortByBalCustom: [],
    supportAdminPermissionList: null,
    typeIdFromName: null,
    activeSupportAdminList: null,
    inActiveSupportAdminList: null,
    supportAdminInfo: null,
  },


  mutations: {
    SET_SUBMIT_REKYC(state, payload) {
      state.submitKYCResponse = payload;
    },
    SET_SKIP_REKYC_OPERATION(state, payload) {
      state.skipReKYCOperationResponse = payload;
    },
    SET_PDF_DATA(state, payload) {
      state.setPdfDate = payload;
    },
    GET_SEL_COMPANY_LIST(state, payload) {
      state.getAllCompanyList = payload;
    },
    UPDATE_COMPANY_INFO(state, payload) {
      state.updatedCompInfo = payload;
    },
    SET_COMPANY_BUDGET_HISTORY_INFO(state, payload) {
      state.setCompanyBudgetHistory = payload;
    },
    SET_CATEGORY_COUNT(state, payload) {
      state.totalCategoryCount = payload;
    },
    SET_COMPANY_KYC_DATA(state, payload) {
      state.setKycData = payload;
    },
    SET_COMPANY_UPDATE_DATA(state, payload) {
      state.companyUpdateData = payload;
    },
    GET_COMPANY_HISTORY_LIST(state, payload) {
      state.getCompanyHistory = payload;
    },
    GET_ALL_COMPANY_LIST(state, payload) {
      state.getAllCompanyName = payload;
    },
    SET_NEW_ADDRESS(state, payload) {
      state.NewAddress = payload;
    },
    SET_NEW_BILLING_ADDRESS(state, payload) {
      state.NewBillingAddress = payload;
    },
    // will use in future
    SET_OF_CHILD_COMPANY(state, payload) {
      state.listOfChildCompany = payload;
    },
    RETURN_CHILD_COMPANY(state, payload) {
      state.addReturnChild = payload;
    },
    RETURN_REMOVE_CHILD_COMPANY(state, payload) {
      state.removeReturnChild = payload;
    },
    GET_COMPANY_USERS_LIST(state, payload) {
      state.getCompanyWiseUsers = payload;
    },
    GET_COMPANIES_LIST_ORDERBY_BAL(state, payload) {
      state.getCompaniesSortByBal = payload;
    },
    GET_COMPANIES_LIST_ORDERBY_BAL_CUSTOM(state, payload) {
      state.getCompaniesSortByBalCustom = payload;
    },
    SET_ACH_NETWORK(state, payload) {
      state.achNetworks = payload;
    },
    SET_METAL_CARD_LIST(state, payload) {
      state.metalCardList = payload;
    },
    GET_INDUSTRY_CLASSIFICATION_LIST(state, payload) {
      state.industryClassificationList = payload;
    },
    GET_BUSINESS_CLASSIFICATION_LIST(state, payload) {
      state.businessClassificationList = payload;
    },
    SET_COMPANY_CLASSIFICATION_UPDATE_DATA(state, payload) {
      state.updatedCompClassInfo = payload;
    },
    GET_SUPPORT_ADMIN_PERMISSION_LIST(state, payload) {
      state.supportAdminPermissionList = payload;
    },
    GET_TYPEID_FROM_NAME(state, payload) {
      state.typeIdFromName = payload;
    },
    GET_SUPPORT_ACTIVE_ADMIN_LIST(state, payload) {
      state.activeSupportAdminList = payload;
    },
    GET_SUPPORT_INACTIVE_ADMIN_LIST(state, payload) {
      state.inActiveSupportAdminList = payload;
    },
    GET_SUPPORT_ADMIN_INFO(state, payload) {
      state.supportAdminInfo = payload;
    },

  },

  actions: {
    // = methods
    // destructuring `context.commit` by doing `{ commit }`

    async getSelCompanies({ commit }, payload) {
      commit('shared/SET_LOADING_CHILD', true, {
        root: true,
      });

      await apolloClient
        .query({
          query: GET_USER_COMPANY_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getSelCompaniesdata) => {
          getSelCompaniesdata.data.companies.forEach((company) => {
            const users = [];
            company.users.forEach((user) => {
              if (user.UserSettings.length > 0) {
                users.push(user);
              }
            });
            company.users = users;
          });
          commit('shared/SET_LOADING_CHILD', true, {
            root: true,
          });
          commit('GET_SEL_COMPANY_LIST', getSelCompaniesdata.data.companies);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        })
        .catch(getSelCompanieserr => {
          console.log(getSelCompanieserr);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        });
    },

    getAllCompanies({ commit }, payload) {
      console.log(payload);
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .query({
          query: GET_COMPANY_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(( getAllCompaniesData ) => {
          commit('GET_ALL_COMPANY_LIST', getAllCompaniesData.data.companies);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getAllCompaniesErr => {
          console.log(getAllCompaniesErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getCompanyHistories({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .query({
          query: GET_COMPANY_HISTORY_GQL,
          variables: payload,
        })
        .then(( getCompanyHistoriesData ) => {
          commit('GET_COMPANY_HISTORY_LIST', getCompanyHistoriesData.data.companyBudgetHistories);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getCompanyHistorieserr => {
          console.log(getCompanyHistorieserr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getAchNetwork({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .query({
          query: GET_ACH_NETWORK_GQL,
          variables: payload,
        })
        .then(( getAchNetworkData ) => {
          commit('SET_ACH_NETWORK', getAchNetworkData.data.getAchNetwork);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getAchNetworkerr => {
          console.log(getAchNetworkerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async updateCmpdetail({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_COMPANY_GQL,
          variables: {
            id: payload.id,
            creditLimit: parseFloat(payload.creditLimit),
            ledgerBalance: parseFloat(payload.ledgerBalance),
            status: payload.status,
            creditLimitByPercentage: parseFloat(payload.creditLimitByPercentage),
            maxCreditLimit: parseFloat(payload.maxCreditLimit),
            physicalCardLimit: Number(payload.physicalCardLimit),
            companyTabStatus: payload.companyTabStatus,
            paymentCycle: payload.paymentCycle,
            visaFraudsCrore: Number(payload.visaFraudsCrore),
            isWeeklySummeryEnable: payload.isWeeklySummeryEnable,
            shippingMethods: payload.shippingMethods,
            overrideBalancedue: payload.overrideBalancedue,
            achType: payload.achType,
            isDailyAch: payload.isDailyAch,
            dailyAchAmount: parseFloat(payload.dailyAchAmount),
            allowMetalCard: payload.allowMetalCard,
            LockDownStatus: payload.LockDownStatus,
            isLockDown: payload.isLockDown,
            highLimitCardSetting: payload.highLimitCardSetting,
            canCreateChildCompany: payload.canCreateChildCompany,
            canConnectExternalCreditCard: payload.canConnectExternalCreditCard,
            supportAdminId: payload.supportAdminId,
            otpForMasqueradeLogin: payload.otpForMasqueradeLogin,
            activityStatus: payload.activityStatus,
            other: payload.other,
            comment: payload.comment,
            nextStep: payload.nextStep,
            source: payload.source,
            noOfEmployees: parseInt(payload.noOfEmployees),
            annualRevenue: parseFloat(payload.annualRevenue),
            noOfTotalCards: parseInt(payload.noOfTotalCards),
            ceoName: payload.ceoName,
            cfoName: payload.cfoName,
            controllerName: payload.controllerName,
            companyType: payload.companyType,
            companyMobile: payload.companyMobile,
            companyAddress: payload.companyAddress,
            companyCity: payload.companyCity,
            companyZip: payload.companyZip,
            stateId: payload.stateId,
            agilLinkOnlineFirmCode: payload.agilLinkOnlineFirmCode,
          },
        })
        .then(( updateCmpdetailData ) => {
          commit('UPDATE_COMPANY_INFO', updateCmpdetailData.data.updateCompany);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((updateCmpdetailErr) => {
          console.log(updateCmpdetailErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    addCompanyBudgetHistory({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: ADD_COMPANY_BUDGET_HISTORY_GQL,
          variables: {
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            allocatedBudget: payload.allocatedBudget,
            companyId: payload.companyId,
            userId: payload.userId,
          },
        })
        .then(( addCompanyBudgetHistoryData ) => {
          commit('SET_COMPANY_BUDGET_HISTORY_INFO', addCompanyBudgetHistoryData.data.createcompanyBudgetHistory);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((addCompanyBudgetHistoryErr) => {
          console.log(addCompanyBudgetHistoryErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    copyCategory({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: COPY_CATEGORY_GQL,
          variables: {
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            companyId: payload.companyId,
          },
        })
        .then(( copyCategoryData ) => {
          commit('SET_CATEGORY_COUNT', copyCategoryData.data.text);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(copyCategoryErr => {
          console.log(copyCategoryErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    createBusinessKYC({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_COMPANY_KYC,
          variables: {
            token: payload.id,
          },
        })
        .then(( createBusinessKYCData ) => {
          commit('SET_COMPANY_KYC_DATA', createBusinessKYCData.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(createBusinessKYCErr => {
          console.log(createBusinessKYCErr);
          commit('SET_COMPANY_KYC_DATA', { error: 'Something is wrong' });
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getPdf({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_PDF_HISTORY,
          variables: {
            companyId: payload.companyId,
            recordStatus: 1,
          },
        })
        .then(( getPdfData ) => {
          commit('SET_PDF_DATA', getPdfData.data.pdfHistories);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getPdfErr => {
          console.log(getPdfErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    updateCompany({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_COMPANY_DATA_GQL,
          variables: {
            ...payload,
          },
        })
        .then(( updateCompanyData ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_COMPANY_UPDATE_DATA', updateCompanyData.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(updateCompanyErr => {
          console.log(updateCompanyErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    submitNewAddress({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .mutate({
          mutation: PUT_NEW_ADDRESS,
          variables: {
            ...payload,
          },
        })
        .then(( submitNewAddressData ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_NEW_ADDRESS', submitNewAddressData.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(submitNewAddressErr => {
          console.log(submitNewAddressErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    submiBillingAddress({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .mutate({
          mutation: PUT_NEW_BILLING_ADDRESS,
          variables: {
            ...payload,
          },
        })
        .then(( submiBillingAddressData ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_NEW_BILLING_ADDRESS', submiBillingAddressData.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(submiBillingAddressErr => {
          console.log(submiBillingAddressErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    makeChildCompany({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .mutate({
          mutation: SET_CHILD_COMPANIES,
          variables: {
            ...payload,
          },
        })
        .then(( makeChildCompanyData ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });

          commit('RETURN_CHILD_COMPANY', makeChildCompanyData.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(makeChildCompanyErr => {
          console.log(makeChildCompanyErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getChildCompany({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_CHILD_COMPANIES,
          variables: {
            ...payload,
          },
        })
        .then(( getChildCompanyData ) => {
          commit('SET_OF_CHILD_COMPANY', getChildCompanyData.data.companies);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getChildCompanyErr => {
          console.log(getChildCompanyErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    removeChildCompany({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .mutate({
          mutation: REMOVE_CHILD_COMPANIES,
          variables: {
            ...payload,
          },
        })
        .then(( removeChildCompanyData ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });

          commit('RETURN_REMOVE_CHILD_COMPANY', removeChildCompanyData.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(removeChildCompanyErr => {
          console.log(removeChildCompanyErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getCompanyUsers({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .query({
          query: GET_COMPANY_USERS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getCompanyUsersData) => {
          commit('GET_COMPANY_USERS_LIST', getCompanyUsersData.data.getCompanyUsers);
        })
        .catch(getCompanyUsersErr => {
          commit('GET_COMPANY_USERS_LIST', { status: 'failure', error: getCompanyUsersErr.message });
        });
    },

    getMetalCardList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .query({
          query: GET_METAL_CARD_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(( getMetalCardListData ) => {
          commit('SET_METAL_CARD_LIST', getMetalCardListData.data.metalCards);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getMetalCardListErr => {
          console.log(getMetalCardListErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async getCompaniesOrderByBal({ commit }) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      await apolloClient
        .query({
          query: GET_COMPANIES_ORDER_BY_BAL_GQL,
          variables: {
            totalSpend: 0,
          },
          fetchPolicy: 'no-cache',
        })
        .then(( getCompaniesOrderByBalData ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('GET_COMPANIES_LIST_ORDERBY_BAL', getCompaniesOrderByBalData.data.companies);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getCompaniesOrderByBalErr => {
          console.log(getCompaniesOrderByBalErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async getCompaniesOrderByBalCustom({ commit }) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      await apolloClient
        .query({
          query: GET_COMPANIES_ORDER_BY_BAL_GQL_CUSTOM,
          variables: {
            totalSpend: 0,
          },
          fetchPolicy: 'no-cache',
        })
        .then(( getCompaniesOrderByBalCustomData ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('GET_COMPANIES_LIST_ORDERBY_BAL_CUSTOM', getCompaniesOrderByBalCustomData.data.companiesCustom);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getCompaniesOrderByBalCustomErr => {
          console.log(getCompaniesOrderByBalCustomErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getIndustryClassificationList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .query({
          query: GET_INDUSTRY_CLASSIFICATION_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(( getIndustryClassificationListData ) => {
          commit('GET_INDUSTRY_CLASSIFICATION_LIST', getIndustryClassificationListData.data.industryClassifications);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getIndustryClassificationListErr => {
          console.log(getIndustryClassificationListErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getBusinessClassificationList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .query({
          query: GET_BUSINESS_CLASSIFICATION_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then(( getBusinessClassificationListData) => {
          getBusinessClassificationListData.data.date = new Date();
          commit('GET_BUSINESS_CLASSIFICATION_LIST', getBusinessClassificationListData.data.businessClassifications);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getBusinessClassificationListErr => {
          console.log(getBusinessClassificationListErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    updateCompanyClassification({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .mutate({
          mutation: UPDATE_COMPANY_CLASSIFICATION_DATA_GQL,
          variables: {
            ...payload,
          },
        })
        .then(( updateCompanyClassificationData ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_COMPANY_CLASSIFICATION_UPDATE_DATA', updateCompanyClassificationData.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(updateCompanyClassificationErr => {
          console.log(updateCompanyClassificationErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getSupportAdminPermission({ commit }) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_SUPPORT_ADMIN_PERMISSION_LIST_GQL,
        })
        .then(( getSupportAdminPermissionData ) => {
          commit('GET_SUPPORT_ADMIN_PERMISSION_LIST', getSupportAdminPermissionData.data.supportAdminPermissions);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getSupportAdminPermissionErr => {
          console.log(getSupportAdminPermissionErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getTypeIdFromName({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_TYPEID_FROM_NAME_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(( getTypeIdFromNameData ) => {
          commit('GET_TYPEID_FROM_NAME', getTypeIdFromNameData.data.userTypes);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getTypeIdFromNameErr => {
          console.log(getTypeIdFromNameErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getSupportAdmins({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_SUPPORT_ADMIN_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(( getSupportAdminsData ) => {
          if (payload.status) {
            commit('GET_SUPPORT_ACTIVE_ADMIN_LIST', getSupportAdminsData.data.users);
          } else {
            commit('GET_SUPPORT_INACTIVE_ADMIN_LIST', getSupportAdminsData.data.users);
          }

          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getSupportAdminsErr => {
          console.log(getSupportAdminsErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getSupportAdminInfo({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_SUPPORT_ADMIN_INFO_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(( getSupportAdminInfoData ) => {
          commit('GET_SUPPORT_ADMIN_INFO', getSupportAdminInfoData.data.user);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getSupportAdminInfoErr => {
          console.log(getSupportAdminInfoErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    setCompanyListToNull({ commit }) {
      commit('GET_SEL_COMPANY_LIST', []);
    },

    skipReKYCOperation({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_SKIP_REKYC_OPERATION_GQL,
          variables: {
            ...payload,
          },
        })
        .then((skipReKYCOperationData) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_SKIP_REKYC_OPERATION', skipReKYCOperationData.data.skipReKYCOperation);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(skipReKYCOperationErr => {
          console.log(skipReKYCOperationErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    submitReKYC({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_SUBMIT_REKYC_GQL,
          variables: {
            ...payload,
          },
        })
        .then((submitReKYCData) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_SUBMIT_REKYC', submitReKYCData.data.submitReKYC);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(submitReKYCErr => {
          console.log(submitReKYCErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

  },
  getters: {
    // = computed properties
    getAllCompanyList: state => state.getAllCompanyList,
    updatedCompInfo: state => state.updatedCompInfo,
    setCompanyBudgetHistory: state => state.setCompanyBudgetHistory,
    totalCategoryCount: state => state.totalCategoryCount,
    setKycData: state => state.setKycData,
    companyUpdateData: state => state.companyUpdateData,
    getCompanyHistory: state => state.getCompanyHistory,
    getAllCompanyName: state => state.getAllCompanyName,
    setPdfDate: state => state.setPdfDate,
    NewAddress: state => state.NewAddress,
    NewBillingAddress: state => state.NewBillingAddress,
    listOfChildCompany: state => state.listOfChildCompany,
    addReturnChild: state => state.addReturnChild,
    removeReturnChild: state => state.removeReturnChild,
    getCompanyWiseUsers: state => state.getCompanyWiseUsers,
    getCompaniesSortByBal: state => state.getCompaniesSortByBal,
    achNetworks: state => state.achNetworks,
    metalCardList: state => state.metalCardList,
    industryClassificationList: state => state.industryClassificationList,
    businessClassificationList: state => state.businessClassificationList,
    updatedCompClassInfo: state => state.updatedCompClassInfo,
    getCompaniesSortByBalCustom: state => state.getCompaniesSortByBalCustom,
    supportAdminPermissionList: state => state.supportAdminPermissionList,
    typeIdFromName: state => state.typeIdFromName,
    activeSupportAdminList: state => state.activeSupportAdminList,
    inActiveSupportAdminList: state => state.inActiveSupportAdminList,
    supportAdminInfo: state => state.supportAdminInfo,
    skipReKYCOperationResponse: state => state.skipReKYCOperationResponse,
    submitKYCResponse: state => state.submitKYCResponse,
  },
};
